import {useDebugValue} from 'react';

import {undef, noop, DEFAULT_MODAL_ANIMATION_TYPE} from '../../../utils';

import {useOptions} from './';

const defaultOptions = {
    id: 'search-details',
    fixedBody: undef,
    parentNode: undef,
    portalClassName: undef,
    isContextual: false,
    isInstructional: false,
    isWorkflow: true,
    title: undef,
    footer: undef,
    showBackdrop: undef,
    showHeader: true,
    showCloseButton: true,
    closeOnEsc: true,
    closeOnOutsideClick: undef,
    animation: DEFAULT_MODAL_ANIMATION_TYPE,
    timeouts: undef,
    scrollTop: undef,
    scrollToTop: noop
};

function useDetailsModalOptions(props) {
    const {
        detailsModalOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalOptions};
